import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet.heat';

export interface PontoCalor {
  lat: number;
  lng: number;
  /** Peso do ponto na densidade — default 1 (cada ponto conta igual). */
  intensidade?: number;
}

interface HeatmapLayerProps {
  pontos: PontoCalor[];
  radius?: number;
  blur?: number;
}

/**
 * Camada de mapa de calor genérica — não sabe nada sobre pesca/domínio, só
 * recebe uma lista de pontos e desenha a densidade via leaflet.heat (mesma
 * lib usada em qualquer outro mapa que precise dessa visualização). Some
 * e volta junto com a lista de `pontos` (útil pra alternar visualização
 * sem duplicar o MapContainer).
 */
const HeatmapLayer: React.FC<HeatmapLayerProps> = ({ pontos, radius = 25, blur = 20 }) => {
  const map = useMap();

  useEffect(() => {
    const latlngs: [number, number, number][] = pontos.map((p) => [p.lat, p.lng, p.intensidade ?? 1]);
    const layer = L.heatLayer(latlngs, { radius, blur, maxZoom: 17 }).addTo(map);
    return () => {
      map.removeLayer(layer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, pontos, radius, blur]);

  return null;
};

export default HeatmapLayer;
